'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ModalBackButton = require('../../lib/ModalBackButton');

var _ModalBackButton2 = _interopRequireDefault(_ModalBackButton);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = require('merge-theme-hoc');

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'backButtonClickableArea': 'Default__backButtonClickableArea___20Pmi',
  'backIcon': 'Default__backIcon___30oHQ',
  'backButtonDisabled': 'Default__backButtonDisabled___3UhhH'
};

var DefaultModalBackButton = (0, _mergeThemeHoc2.default)(style)(_ModalBackButton2.default);
DefaultModalBackButton.displayName = 'DefaultModalBackButton';
exports.default = DefaultModalBackButton;


//////////////////
// WEBPACK FOOTER
// ./~/dibs-elements/dist/ModalBackButton/index.js
// module id = 848
// module chunks = 4 5 8 9 14